const initialStateMarketingPreference = {
  ownOffers: [],
  thirdPartyOffers: [],
};

const initialStateMarketingConsents = {
  marketingConsents: [],
};

export function setMarketingCommunicationsPreference({ state = initialStateMarketingPreference, action }) {
  return { ...state, ownOffers: action.offerParams.ownOffers, thirdPartyOffers: action.offerParams.thirdPartyOffers };
}

export function setMarketingCommunicationsConsents({ state = initialStateMarketingConsents, action }) {
  return { ...state, marketingConsents: action.marketingConsents };
}
